<template>
  <div class="mb-1">
    <div class="buying-zone__form-label-group">
      <span class="font-semibold" v-html="label" />
    </div>
    <div v-if="items.length">
      <div ref="grid" :style="gridStyle">
        <product-attribute-button
          v-for="option in attribute"
          :key="option.value"
          :base-properties="baseProperties"
          :option="option"
          :product="product"
          :attribute="attribute"
          :selected-option="selectedOption"
          @change="setSelectedOption"
        />
      </div>
    </div>
    <div v-if="selectedOption && children && children.length > 0">
      <component
        :is="getAttributeComponent(children)"
        :product="product"
        :base-properties="baseProperties"
        :init-attribute-selection="initAttributeSelection"
        :label="getAttributeLabel(children)"
        :render-stock-status="renderStockStatus"
        :stock-message="stockMessage"
        :is-loading-stock-data="isLoadingStockData"
        :attribute="children"
        @color-changed="
          (color) => {
            $emit('color-changed', color);
          }
        "
        @product-selected="productSelected"
      />
    </div>
  </div>
</template>
<script>
import {Attribute} from '@/components/containers/pdp/attributes/mixins/attribute';
import {AttributeRenderer} from '@/components/containers/pdp/attributes/mixins/attribute-renderer';
import ProductAttributeButton from '@/components/containers/pdp/attributes/ProductAttributeButton';
import get from 'lodash/get';
import {mapMutations} from 'vuex';

export default {
  name: 'ProductAttributeButtonGrid',
  components: {ProductAttributeButton},
  mixins: [Attribute, AttributeRenderer],
  props: {
    gap: {
      type: Number,
      default: 8,
    },
    initAttributeSelection: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isCalculated: false,
      columns: 0,
      maxWidth: 0,
      resizeTimeout: null,
      selectedOption: null,
    };
  },
  computed: {
    items() {
      let items = [
        {
          value: '',
          disabled: true,
          id: '',
          displayName: window.ACC?.isB2Bsite ? this.bp('selectVariantB2B') : this.bp('selectVariant'),
        },
      ];

      const metaItemCodes = this.getAttributeMetadataCodes();
      this.attribute.forEach((item) => {
        if (metaItemCodes.includes(item.code)) {
          items.push({
            value: item.options.displayName,
            id: item.options.displayName,
            displayName: item.options.displayName,
          });
        }
      });

      return items;
    },
    classes() {
      return {
        'product-attribute-button-grid': this.isCalculated,
      };
    },
    gridStyle() {
      return {
        display: this.isCalculated ? 'grid' : 'block',
        'grid-template-columns': `repeat(${this.columns}, 1fr)`,
        gap: `${this.gap}px`,
      };
    },
    children() {
      return get(this.selectedOption, 'children', []);
    },
  },
  watch: {
    selectedOption() {
      this.fireSelectedProduct();
    },
    attribute() {
      let attributeComboExists = false;
      this.attribute.forEach((option) => {
        if (option.value === this.selectedOption.value) {
          attributeComboExists = true;
        }
      });
      if (!attributeComboExists) {
        this.selectedOption = this.attribute[0];
      }
    },
  },
  created() {
    this.initSelectedAttribute();
  },
  mounted() {
    this.initSizes();
    window.addEventListener('resize', this.calculateColumns);
  },
  unmounted() {
    window.removeEventListener('resize', this.calculateColumns);
  },

  methods: {
    ...mapMutations('savedLists', ['setBuyingZoneEntries']),
    initSizes() {
      let widths = Array.from(this.$refs.grid?.children).map((b) => b.offsetWidth);
      this.maxWidth = Math.max(...widths) + this.gap;
      this.isCalculated = true;
      this.calculateColumns();
    },
    calculateColumns() {
      if (this.$refs.grid) {
        let containerWidth = this.$refs.grid.clientWidth;
        this.columns = Math.floor(containerWidth / this.maxWidth);
      }
    },

    setSelectedOption(value) {
      this.selectedOption = value.option;
    },

    initSelectedAttribute() {
      const initValue = get(this.initAttributeSelection, this.attribute[0].code);
      if (!initValue) {
        if (this.items.length - 1 === 1) {
          this.attribute.forEach((option) => {
            if (option.options.displayName === this.items[1].value) {
              this.selectedOption = option;
            }
          });
        }
      } else {
        this.attribute.forEach((option) => {
          if (option.options.displayName === initValue) {
            this.selectedOption = option;
          }
        });
      }
    },
    fireSelectedProduct() {
      const productCode = get(this.selectedOption, 'options');
      if (productCode) {
        this.productSelected(productCode);
        this.setBuyingZoneEntries([{sku: productCode.productCode, qty: 1}]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.product-attribute-button-grid {
  display: grid;
  grid-template-columns: 1fr;
}
</style>
